module.exports = __webpack_public_path__ + "static/img/pro-icon.05aff3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro-icon.png
// module id = eTqI
// module chunks = 1